
import axios from "axios";

import { fetchClan } from "./ActionClanProfile";

export const SET_CLAN_BATTLES = 'SET_CLAN_BATTLES';
export const TOGGLE_BATTLES_ERROR = 'TOGGLE_BATTLES_ERROR';
export const TOGGLE_SELECTED_BATTLE = 'TOGGLE_SELECTED_BATTLE';
export const TOGGLE_CLAN_BATTLES_FETCH = 'TOGGLE_CLAN_BATTLES_FETCH';

export type SET_SELECTED_CLANBATTLES_TAB_TYPE = "SET_SELECTED_CLANBATTLES_TAB";
export const SET_SELECTED_CLANBATTLES_TAB: SET_SELECTED_CLANBATTLES_TAB_TYPE = 'SET_SELECTED_CLANBATTLES_TAB';
export const setSelectedTab = (selectedTab: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_SELECTED_CLANBATTLES_TAB,
    payload: {
      selectedTab: selectedTab
    }
  });
};

export type SET_SELECTED_TEAM_NUMBER_TYPE = "SET_SELECTED_TEAM_NUMBER";
export const SET_SELECTED_TEAM_NUMBER: SET_SELECTED_TEAM_NUMBER_TYPE = 'SET_SELECTED_TEAM_NUMBER';
export const setSelectedTeamNumber = (teamNumber: number, noFetch?: boolean) => (dispatch: Dispatch, getState: GetState) => {
  const onlySet = !!noFetch;
  dispatch({
    type: SET_SELECTED_TEAM_NUMBER,
    payload: {
      teamNumber
    }
  });
  if (!onlySet) {
    dispatch(getClanBattles());
  }
};

export type CHECK_CLAN_BATTLES_TYPE = "CHECK_CLAN_BATTLES";
export const CHECK_CLAN_BATTLES: CHECK_CLAN_BATTLES_TYPE = 'CHECK_CLAN_BATTLES';
export const checkClanBattles = () => (dispatch: Dispatch, getState: GetState) => {
  let state = getState();

  const executeRequest = leadingTeam => {
    const team = leadingTeam ? leadingTeam : 1;
    dispatch(setSelectedTeamNumber(team, true));
    let url = `${state.urls.ladderClanBattles}?team=${team}`;
    axios.get(url).then(r => {
      const battles = r.data;
      dispatch(setClanBattles(battles));
      dispatch(setClanBattlesFetching(false));
    }).catch(err => {
      dispatch(setClanBattlesFetching(false));
    });
  };

  if (state.currentAccount && state.currentAccount.clanId) {
    dispatch(setClanBattlesFetching(true));
    
    dispatch(fetchClan(state.currentAccount.clanId, true)).then(() => {
      state = getState();
      const wowsLadder = state.clans.wowsLadder[state.currentAccount.clanId];
      const leadingTeamNumber = wowsLadder ? wowsLadder.leading_team_number : null;
      executeRequest(leadingTeamNumber);
    });
  } else {
    executeRequest();
  }
};

export type GET_CLAN_BATTLES_TYPE = "GET_CLAN_BATTLES";
export const GET_CLAN_BATTLES: GET_CLAN_BATTLES_TYPE = 'GET_CLAN_BATTLES';
export const getClanBattles = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  let url = `${state.urls.ladderClanBattles}?team=${state.ReducerClanBattles.teamNumber}`;
  dispatch(setClanBattlesFetching(true));
  axios.get(url).then(r => {
    dispatch(setClanBattles(r.data));
    dispatch(setClanBattlesFetching(false));
  }).catch(err => {
    dispatch(setClanBattlesFetching(false));
  });
};

export type FETCH_CLAN_DATA_TYPE = "FETCH_CLAN_DATA";
export const FETCH_CLAN_DATA: FETCH_CLAN_DATA_TYPE = 'FETCH_CLAN_DATA';
export const fetchClanData = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  if (state.currentAccount && state.currentAccount.clanId) {
    dispatch(fetchClan(state.currentAccount.clanId, true));
  }
};

export type ON_CLICK_BATTLE_TYPE = "ON_CLICK_BATTLE";
export const ON_CLICK_BATTLE: ON_CLICK_BATTLE_TYPE = 'ON_CLICK_BATTLE';
export const onClickBattle = (battleId: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: ON_CLICK_BATTLE,
    payload: {
      battleId
    }
  });
};

export type SET_CLAN_BATTLES_FETCHING_TYPE = "SET_CLAN_BATTLES_FETCHING";
export const SET_CLAN_BATTLES_FETCHING: SET_CLAN_BATTLES_FETCHING_TYPE = 'SET_CLAN_BATTLES_FETCHING';
export const setClanBattlesFetching = (isFetching: boolean) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_CLAN_BATTLES_FETCHING,
    payload: {
      isFetching
    }
  });
};

export type SET_CLAN_BATTLES_TYPE = "SET_CLAN_BATTLES";
export const setClanBattles = (battles: Array<any>) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_CLAN_BATTLES,
    payload: {
      battles
    }
  });
};

export const toggleClanBattlesFetch = isFetching => {
  return {
    type: TOGGLE_CLAN_BATTLES_FETCH,
    isFetching
  };
};

export const toggleBattlesError = (isError, errorMessage) => {
  return {
    type: TOGGLE_BATTLES_ERROR,
    isError,
    errorMessage
  };
};

export const toggleSelectedBattle = selectedBattle => {
  return {
    type: TOGGLE_SELECTED_BATTLE,
    selectedBattle
  };
};